
import { Clock, PictureInPicture2, Check } from 'lucide-react'
import {CustomCard} from '@/components' 

const WhyChoose = () => {
  const features = [
    {
      icon: <Clock className="h-12 w-12 bg-black text-white rounded-full p-3" />,
      title: "Quick Reordering",
      description: "Save your favorite product lists for easy reordering. "
    },
    {
      icon: <PictureInPicture2 className="h-12 w-12 bg-black text-white rounded-full p-3" />,
      title: "Wholesale Pricing",
      description: "Get the best prices for professional salon products."
    },
    {
      icon: <Check className="h-12 w-12 bg-black text-white rounded-full p-3" />,
      title: "Fast Delivery",
      description: "Same day shipping on all orders placed before 2PM."
    }
  ]

  return (
    <div className="py-8 text-center  bg-[#F5F5F5] px-2 ">
      <h2 className=" text-lg md:text-2xl mb-12 font-semibold">Why Choose Palette</h2>
      
      <div className="flex justify-center gap-8 flex-wrap max-w-6xl mx-auto">
      <div className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3  gap-6 px-5 md:px-6 `}>
        {features.map((feature, index) => (
          <CustomCard 
          className='bg-white'
            key={index}
            icon={feature?.icon}
            name={feature?.title}
            description={feature?.description}
          />
        ))}
        </div>
      </div>
    </div>
  )
}

export default WhyChoose